// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img.thumbnail[data-v-9fc2cf3e]{cursor:pointer}.item-count-label[data-v-9fc2cf3e]{color:#4f5050;font-size:10px;padding-top:.4em;margin-right:13px;text-align:center}.c-select--center__label[data-v-9fc2cf3e]{color:#4f5050;font-size:16px}.unit-count[data-v-9fc2cf3e]{font-size:24px}.item-label[data-v-9fc2cf3e],.item-title[data-v-9fc2cf3e]{font-weight:700}", ""]);
// Exports
module.exports = exports;
